import React from 'react';
import { JourneyData } from './services/tflApi';

interface Props {
  areaName: string;
  journey: JourneyData | null;
  visible: boolean;
  cursorX?: number;
  cursorY?: number;
  isBottomPanel?: boolean;
  onClose?: () => void;
}

const MODE_EMOJI: Record<string, string> = {
  walking: '🚶',
  tube: '🚇',
  bus: '🚌',
  overground: '🚆',
  'elizabeth-line': '🚆',
  dlr: '🚈',
  tram: '🚊',
};

function modeEmoji(mode: string): string {
  return MODE_EMOJI[mode] ?? '🚌';
}

export default function CommuteTooltip({ areaName, journey, visible, cursorX, cursorY, isBottomPanel, onClose }: Props) {
  if (!visible) return null;

  const style: React.CSSProperties = isBottomPanel
    ? {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
      }
    : {
        position: 'absolute',
        left: (cursorX ?? 0) + 16,
        top: (cursorY ?? 0) + 16,
        zIndex: 1000,
        pointerEvents: 'none',
      };

  return (
    <div
      className={`commute-tooltip${isBottomPanel ? ' commute-tooltip--bottom' : ''}`}
      style={style}
    >
      <div className="commute-tooltip__header">
        <span className="commute-tooltip__name">{areaName}</span>
        <div className="commute-tooltip__header-right">
          {journey && <span className="commute-tooltip__duration">{journey.duration} min</span>}
          {isBottomPanel && onClose && (
            <button className="commute-tooltip__close" onClick={onClose} aria-label="Close">×</button>
          )}
        </div>
      </div>

      {journey ? (
        <div className="commute-tooltip__journey">
          <div className="commute-tooltip__journey-label">Journey</div>
          <div className="commute-tooltip__journey-steps">
            {journey.legs.map((leg, i) => (
              <React.Fragment key={i}>
                {i > 0 && <span className="commute-tooltip__sep"> → </span>}
                <span className="commute-tooltip__step">
                  {modeEmoji(leg.mode)} {leg.lineName} {leg.duration} min
                </span>
              </React.Fragment>
            ))}
          </div>
        </div>
      ) : (
        <p className="commute-tooltip__no-data">No route data available</p>
      )}
    </div>
  );
}
